export default "__VITE_ASSET__f9c0ad53__"